import { Injectable } from '@angular/core';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { EducationApi } from '../apis/education/education.api';
import { EducationProgramDTO } from '../apis/education/education.dto';
import { RehabilitationApi } from '../apis/rehabilitation/rehabilitation.api';
import { RehabilitationProgramDTO } from '../apis/rehabilitation/rehabilitation.dto';
import { ServiceApi } from '../apis/service/service.api';
import { ServiceDTO } from '../apis/service/service.dto';
import { IBookingStorage } from '../interfaces/booking.interface';
import { StorageService } from './storage.service';

@Injectable({
  providedIn: 'root',
})
@UntilDestroy()
export class ReusableProgramsMethodsService {
  public programsInBasket: number = 0;
  public selectedProgramTitle: string = '';
  protected constructor(
    protected storrageService: StorageService,
    protected educationApi: EducationApi,
    protected rehabilitationApi: RehabilitationApi,
    protected serviceApi: ServiceApi,
  ) {}

  // витягуємо назву програми по приоритету
  // education > rehabilitation > service
  //  для відображення у вікні авторизації чи реєстрації
  getPrograms(): void {
    const programs: IBookingStorage = this.storrageService.getChosenPrograms();

    this.programsInBasket =
      (programs.education?.length ?? 0) + (programs.rehabilitation?.length ?? 0) + (programs.service?.length ?? 0);

    if (programs.education?.length && programs.education.length > 0) {
      this.educationApi
        .getById(programs.education[0])
        .pipe(untilDestroyed(this))
        .subscribe((program: EducationProgramDTO) => {
          this.selectedProgramTitle = program.name;
        });
    } else if (programs.rehabilitation?.length && programs.rehabilitation.length > 0) {
      this.rehabilitationApi
        .getById(programs.rehabilitation[0])
        .pipe(untilDestroyed(this))
        .subscribe((program: RehabilitationProgramDTO) => {
          this.selectedProgramTitle = program.name;
        });
    } else if (programs.service?.length && programs.service.length > 0) {
      this.serviceApi
        .getById(programs.service[0])
        .pipe(untilDestroyed(this))
        .subscribe((program: ServiceDTO) => {
          this.selectedProgramTitle = program.name;
        });
    }
  }
}
